import { render, staticRenderFns } from "./cModalQuotes.vue?vue&type=template&id=5a8a4942&scoped=true"
import script from "./cModalQuotes.vue?vue&type=script&lang=js"
export * from "./cModalQuotes.vue?vue&type=script&lang=js"
import style0 from "./cModalQuotes.vue?vue&type=style&index=0&id=5a8a4942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8a4942",
  null
  
)

export default component.exports